var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,_vm._g(_vm._b({tag:"component",attrs:{"href":_vm.href},scopedSlots:_vm._u([(_vm.glSlots().default)?{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}:null],null,true)},'component',_vm.$attrs,false),_vm.glListeners()))
}
var staticRenderFns = []

export { render, staticRenderFns }